function serviceType(data) {
    let markup = ''
    for (let i = 0; i < data.length; i++) {
        markup += `<li class="tag-wrapper"><span class="tag ${data[i].class}">${data[i].label}</span></li>`
    }
    return markup
}
// prettier-ignore
const template = (data) => `
        <article class="card card--auto-height card--services">
        ${data.noLink ? '<div class="card__link">' : `<a href="${data.url}" class="card__link" target="${data.target}">`}
            <div class="card__content">
                ${data.title ? `<h4 class="card__heading">${data.title}</h4>` : ''}
                ${data.content ? `<p class="card__text">${data.content}</p>` : ''}
                ${data.service_types ? `<ul class="card__tags tag-list">
                    ${serviceType(data.technology_areas)}
                </ul>` : ''}
            </div>
            <div class="card__cta card__cta--button">
                <p class="card__cta-text">${data.cta_text}</p>
            </div>
        ${data.noLink ? '</div>' : '</a>'}
        </article>
`

export default template
